import {
  createRootRouteWithContext,
  createRoute,
  createRouter,
} from "@tanstack/react-router";
import { lazy } from "react";
import type { RouterAppContext } from "@/route-context.ts";
import { RootLayout } from "@/routes/__root.tsx";
import { BugsPage } from "@/routes/bugs.tsx";
import { DocsPage } from "@/routes/docs.tsx";
import { DownloadPage } from "@/routes/download.tsx";
import { HomePage } from "@/routes/index.tsx";

const NotFound = lazy(() =>
  import("@/components/not-found.tsx").then((m) => ({ default: m.NotFound })),
);

const rootRoute = createRootRouteWithContext<RouterAppContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: HomePage,
});

const downloadRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/download",
  component: DownloadPage,
});

const docsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/docs",
  component: DocsPage,
});

const bugsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/bugs",
  component: BugsPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  downloadRoute,
  docsRoute,
  bugsRoute,
]);

export const router = createRouter({
  routeTree,
  context: {
    queryClient: undefined as never,
  },
  defaultPreload: "intent",
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
